import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const toggle = () => {
    const newLang = currentLang === "bg" ? "en" : "bg";
    i18n.changeLanguage(newLang);
    localStorage.setItem("lang", newLang);
  };

  return (
    <button
      onClick={toggle}
      className="inline-flex items-center gap-2 font-mono text-[11px] tracking-wider uppercase border border-border rounded-full px-4 py-1.5 text-foreground/70 hover:text-foreground hover:border-foreground/40 transition-colors"
      aria-label={`Switch to ${currentLang === "bg" ? "English" : "Bulgarian"}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-accent" />
      {currentLang === "bg" ? "EN" : "BG"}
    </button>
  );
};

export default LanguageSwitcher;
